function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 252,
    cy: 252,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324a5e"
    },
    d: "M94.5 389.8h315V284h-38.1v67.7H132.6V284H94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1543f"
    },
    d: "M203.8 208.4V74.8h96.4v133.6h43.6L252 315.9l-91.8-107.5z"
  }));
};
export default SvgDownload;